import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export const selectUser = (state: RootState) => state.user;
export const selectUserId = (state: RootState) => state.user.id;
export const selectUserEmail = (state: RootState) => state.user.email;
export const selectUserName = (state: RootState) => state.user.name;
export const selectUserAvatar = (state: RootState) => state.user.avatar;
export const selectUserLoaded = (state: RootState) => state.user.isLoaded;

export const userAuthorizedSelector = createSelector(
  [selectUser],
  (user) => !!user.id && !user.autoGenerated && !user.autoLogin,
);

export const userEmailSelector = createSelector(
  [userAuthorizedSelector, selectUserEmail],
  (isAuthorized, email) => (isAuthorized ? email : ''),
);

export const userFullNameSelector = createSelector(
  [userAuthorizedSelector, selectUser],
  (isAuthorized, user) => (isAuthorized ? `${user.firstName} ${user.lastName}`.trim() : ''),
);
